// SCO-650: product analytics runs on the production site only. Staging
// (staging.scopeworth.app, staging-www.scopeworth.app), Pages previews, local
// servers and any other host serve the same bundle but never start PostHog,
// so nothing but real production traffic reaches the production project.
// The standalone landings (project-forensics, investigate-roi,
// prove-engineering-value) carry an inline copy of this list.
export const PRODUCTION_ANALYTICS_HOSTS = Object.freeze(['scopeworth.app', 'www.scopeworth.app']);

export function isProductionHost(hostname = typeof window === 'undefined' ? '' : window.location.hostname) {
  return PRODUCTION_ANALYTICS_HOSTS.includes(String(hostname || '').toLowerCase());
}
